<template>
  <div class="replys">
    <ReplyItem
      type="reply"
      :item="replyItem"
      :key="replyItem.pk"
      :owner-info="ownerInfo"
      :has-line="replyIndex !== commentItem.replys.length-1"
      :post-id="commentItem.post"
      v-for="(replyItem, replyIndex) in commentItem.replys"
    />
    <div v-if="commentItem.reply_count > commentItem.replys.length" class="loadMore borderTop" @click.stop="loadMoreReply()">查看更多</div>
</div>
</template>

<script>
// @ is an alias to /src
import ReplyItem from './ReplyItem.vue'

import { types as CommunityTypes } from "@/store/modules/community";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";

export default {
  name: "Replys",
  components: {
    ReplyItem
  },
  props: {
    ownerInfo:{
      type: Object
    },
    commentItem:{
      type: Object
    }
  },
  data() {
    return {
      page: 1
    };
  },
  watch: {
    /*
    // 监听回复列表请求
    reply_data(value){
      let response = value
      // 这里判断一下请求所用的评论 id 是否与当前组件一致。
      if(this.commentItem.pk === response.comment_id){
        // console.log("监听回复列表请求", value);
        if (response.next) {
          this.load_more = true;
        } else {
          this.load_more = false;
        }

        if(this.page === 1){
          this.data = response.results
        }else{
          this.data = this.data.concat(response.results)
        }
        this.total_count = response.count
      }
    },

    // 监听新增回复请求
    watch_create_data(value){
      let response = value
      if(response.type === 'reply' && response.comment === this.commentItem.pk){
        // console.log("监听新增回复请求", value);
        this.data.unshift(response)
      }
    },

    // 监听点赞回复请求
    watch_zan_data(value){
      let response = value
      if(response.type === 'reply' && response.comment === this.commentItem.pk){
        // console.log("监听点赞回复请求", value);
        let target_item = this.data.find(item=>item.pk=== response.pk)
        if(target_item){
          if (target_item.is_like === true) {
            target_item['is_like'] = false
            target_item['like_count'] -= 1
          } else {
            target_item['is_like'] = true
            target_item['like_count'] += 1
          }
        }
      }
    },
    // 监听删除回复请求
    watch_delete_data(value){
      let response = value
      if(response.type === 'reply'){
        // console.log("监听删除回复请求", value);
        this.data = this.data.filter(item=>item.pk !== response.pk)
      }
    },
    // 监听送花回复请求
    watch_flower_data(value){
      let response = value
      if(response.type === 'reply' && response.comment === this.commentItem.pk){
        // console.log("监听送花回复请求", value);
        let target_item = this.data.find(item=>item.pk=== response.record_id)
        if (target_item) {
          if (target_item.is_flower === true) {
            target_item['is_flower'] = false
            target_item['flower_count'] -= 1
          } else {
            target_item['is_flower'] = true
            target_item['flower_count'] += 1
          }
        }
      }
    },
    // 监听关注回复请求
    watch_follow_data(value){
      let response = value
      if(response.type === 'reply'){
        console.log("监听关注回复请求", value);
        let followers = response.followers
        this.data.map(item=>{
          if(followers.includes(item.owner.user)){
            item['is_follow'] = !item.is_follow
          }
        })
      }
    }
    */
  },
  computed: {
    ...mapState({
      // reply_data: state => state.community.reply_data,
      // watch_create_data: state => state.community.watch_create_data,
      // watch_zan_data: state => state.community.watch_zan_data,
      // watch_delete_data: state => state.community.watch_delete_data,
      // watch_flower_data: state => state.community.watch_flower_data,
      // watch_follow_data: state => state.community.watch_follow_data,

    })
  },
  methods: {
    ...mapActions({
      fetchReplyList: CommunityTypes.FETCH_REPLY_LIST
    }),

    loadMoreReply(){
      if(this.commentItem.replys.length < 10){
        this.page = 1
      }else{
        this.page += 1
      }
      console.log(`加载更多回复(${this.commentItem.pk})`, this.page)
      this.fetchReplyList({"page":this.page, "comment_id":this.commentItem.pk});
    },

    //----------子组件 ReplyItem 的回调函数
    //点赞评论或回复
    likeReplyEvent(type, data) {
      if(this.$parent.likeReplyEvent){
        this.$parent.likeReplyEvent(type, data)
      }
    },
    // 删除事件
    deleteReplyEvent(type, data) {
      if(this.$parent.deleteReplyEvent){
        this.$parent.deleteReplyEvent(type, data)
      }
    },
    // 送花事件
    flowerReplyEvent(type, data){
      if(this.$parent.flowerReplyEvent){
        this.$parent.flowerReplyEvent(type, data)
      }
    },
    
    //对评论的回复或对回复的回复
    publishReply(type, data) {
      if(this.$parent.publishReply){
        this.$parent.publishReply(type, data)
      }
    },
    // 关注事件
    followReplyEvent(type, data){
      if(this.$parent.followReplyEvent){
        this.$parent.followReplyEvent(type, data)
      }
    },
  },
  created() {
  },
  destroyed() {
  },
  mounted() {
  }
};
</script>

<style lang="less" scoped>
.replys{
  width: 100%;
}
.loadMore{
  display: block;
  height: 35px;
  line-height: 35px;
  text-align: center;
  margin-bottom: -10px;
  font-size: 12px;
  cursor: pointer;
  &.borderTop{
    border-top-style: solid;
    border-top-width: 1px;
    border-color: #d9d9d9;
  }
}
</style>
